module.exports = __webpack_public_path__ + "static/Green-Olives-with-Lemon-&-Garlic-f8fc53e33e42675ef01dee0eb29767a1.png";